export default "/_next/static/media/video.4361925b.mp4";